// extracted by mini-css-extract-plugin
module.exports = {"teams":"Teams_teams__3Tm3h","teamsList":"Teams_teamsList__15q5q","dataContainer":"Teams_dataContainer__2lw3B","teamMembers":"Teams_teamMembers__L4JVE"};